// src/components/notesdefrais/DetailNoteDeFraisMobile.js

import React, { useState, useEffect } from 'react';
import noteDeFraisStorage from '../../services/noteDeFraisStorage';

const CATEGORIES = {
  repas: '🍽️ Repas',
  deplacement_vehicule: '🚗 Déplacement',
  peage: '🛣️ Péage',
  hotel: '🏨 Hôtel',
  transport_public: '🚆 Transport',
  parking: '🅿️ Parking',
  fournitures: '📦 Fournitures',
  divers: '📋 Divers'
};

const STATUTS = {
  brouillon: { label: 'Brouillon', color: '#94a3b8' },
  soumise: { label: 'Soumise', color: '#3b82f6' },
  validee: { label: 'Validée', color: '#10b981' },
  refusee: { label: 'Refusée', color: '#ef4444' },
  remboursee: { label: 'Remboursée', color: '#8b5cf6' }
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #d1fae5, #a7f3d0)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #10b981, #059669)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  content: {
    padding: '20px'
  },
  card: {
    background: 'white',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
  },
  cardTitle: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#065f46',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  montantBig: {
    fontSize: '48px',
    fontWeight: '900',
    color: '#10b981',
    textAlign: 'center',
    marginBottom: '8px'
  },
  categorieBadge: {
    display: 'inline-block',
    padding: '8px 16px',
    background: '#ecfdf5',
    color: '#065f46',
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '20px'
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 0',
    borderBottom: '1px solid #e5e7eb'
  },
  infoLabel: {
    fontSize: '14px',
    color: '#6b7280',
    fontWeight: '600'
  },
  infoValue: {
    fontSize: '14px',
    color: '#111827',
    fontWeight: '600',
    textAlign: 'right'
  },
  photoPreview: {
    borderRadius: '12px',
    overflow: 'hidden',
    border: '2px solid #10b981',
    marginTop: '12px'
  },
  photoImage: {
    width: '100%',
    height: 'auto',
    display: 'block'
  },
  statutBadge: {
    display: 'inline-block',
    padding: '8px 16px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: '700',
    color: 'white'
  },
  actionButtons: {
    position: 'fixed',
    bottom: '20px',
    left: '20px',
    right: '20px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px'
  },
  editBtn: {
    padding: '16px',
    background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  },
  deleteBtn: {
    padding: '16px',
    background: 'linear-gradient(135deg, #ef4444, #dc2626)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  },
  syncBadge: {
    display: 'inline-block',
    padding: '6px 12px',
    background: '#fef3c7',
    color: '#92400e',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '600',
    marginTop: '12px'
  }
};

function DetailNoteDeFraisMobile({ noteId, onBack, onDelete }) {
  const [note, setNote] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNote();
  }, [noteId]);

  const loadNote = async () => {
    setLoading(true);
    try {
      const noteData = await noteDeFraisStorage.getNote(noteId);
      setNote(noteData);
    } catch (error) {
      console.error('❌ Erreur chargement note:', error);
      alert('❌ Erreur lors du chargement');
      onBack();
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Supprimer cette note de frais ?')) return;

    try {
      await noteDeFraisStorage.deleteFromBase44(noteId);
      alert('✅ Note supprimée');
      if (onDelete) onDelete();
    } catch (error) {
      console.error('❌ Erreur suppression:', error);
      alert('❌ Erreur lors de la suppression');
    }
  };

  const handleEdit = () => {
    alert('🚧 Fonctionnalité d\'édition en cours de développement');
  };

  if (loading) {
    return (
      <div style={{ ...styles.container, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '4px solid #e2e8f0', borderTopColor: '#10b981', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
          <p style={{ marginTop: '16px', color: '#059669', fontWeight: '500' }}>Chargement...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  if (!note) {
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <button style={styles.backBtn} onClick={onBack}>← Retour</button>
          <h1 style={styles.headerTitle}>Note introuvable</h1>
          <div></div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>Détails</h1>
        <div style={{ width: '70px' }}></div>
      </div>

      <div style={styles.content}>
        {/* Montant principal */}
        <div style={styles.card}>
          <div style={styles.montantBig}>
            {note.montant?.toFixed(2)}€
          </div>
          
          <div style={{ textAlign: 'center' }}>
            <span style={styles.categorieBadge}>
              {CATEGORIES[note.categorie]}
            </span>
          </div>

          <div style={{ textAlign: 'center' }}>
            <span style={{ ...styles.statutBadge, background: STATUTS[note.statut].color }}>
              {STATUTS[note.statut].label}
            </span>
          </div>

          {!note.synced && (
            <div style={{ textAlign: 'center' }}>
              <span style={styles.syncBadge}>
                🔄 Non synchronisée
              </span>
            </div>
          )}
        </div>

        {/* Détails */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>
            📋 Informations
          </h3>

          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>Date</span>
            <span style={styles.infoValue}>
              {new Date(note.date_depense).toLocaleDateString('fr-FR', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </span>
          </div>

          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>Description</span>
            <span style={styles.infoValue}>{note.description}</span>
          </div>

          {note.trajet && (
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Trajet</span>
              <span style={styles.infoValue}>{note.trajet}</span>
            </div>
          )}

          {note.client_visite && (
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Client visité</span>
              <span style={styles.infoValue}>{note.client_visite}</span>
            </div>
          )}

          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>Mois comptable</span>
            <span style={styles.infoValue}>
              {new Date(note.mois_comptable + '-01').toLocaleDateString('fr-FR', {
                month: 'long',
                year: 'numeric'
              })}
            </span>
          </div>

          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>Créée le</span>
            <span style={styles.infoValue}>
              {new Date(note.created_at).toLocaleDateString('fr-FR')}
            </span>
          </div>
        </div>

        {/* Photo */}
        {(note.ticket_photo_base64 || note.ticket_photo_url) && (
          <div style={styles.card}>
            <h3 style={styles.cardTitle}>
              📸 Justificatif
            </h3>
            <div style={styles.photoPreview}>
              <img 
                src={note.ticket_photo_base64 || note.ticket_photo_url} 
                style={styles.photoImage} 
                alt="Ticket" 
              />
            </div>
          </div>
        )}
      </div>

      {/* Actions */}
      {note.statut === 'brouillon' && (
        <div style={styles.actionButtons}>
          <button style={styles.editBtn} onClick={handleEdit}>
            ✏️ Modifier
          </button>
          <button style={styles.deleteBtn} onClick={handleDelete}>
            🗑️ Supprimer
          </button>
        </div>
      )}
    </div>
  );
}

export default DetailNoteDeFraisMobile;